<template>
    <div>
        <label class="block text-sm font-medium leading-5 text-gray-800 relative"
            :class="{'required': required, 'font-bold' : bold}"
            :for="name"
            v-if="label">
            <span v-html="label"></span>
            <font-awesome-icon class="text-xs text-black ml-1 cursor-pointer"
                :icon="['fas', 'question-circle']"
                style="margin-top: 2px;"
                v-if="tooltip" v-tooltip="tooltip" />
        </label>
        <div class="mt-1">
            <ValidationProvider :name="providerName ? providerName : label" mode="lazy" :rules="rules" v-slot="{ errors }" tag="div">
                <div class="mt-1" :class="[{ 'input-dollar' : dollar, 'input-percent' : percent }, 'input-'+suffix ]">
                    <the-mask v-if="mask"
                        :type="type ? type : 'text'"
                        :mask="mask"
                        :masked="true"
                        :value="value"
                        :id="name"
                        @input="onInput"
                        :name="name"
                        :ref="name"
                        :placeholder="placeholder ? placeholder : ''"
                        :readonly="readonly"
                        autocomplete="false"
                        data-lpignore="true"
                        v-model="model"
                        class="form-input block w-full transition duration-150 ease-in-out sm:text-sm leading-none text-gray-700"
                        :class="{ 'border-red-700' : errors[0], 'opacity-50 cursor-not-allowed' : disabled, 'readonly bg-gray-200 cursor-default border-gray-400' : readonly }" />
                    <input v-else
                        :type="type ? type : 'text'"
                        v-model="model"
                        :value="value"
                        :id="name"
                        @input="onInput"
                        @blur="onBlur"
                        :name="name"
                        :ref="name"
                        :placeholder="placeholder ? placeholder : ''"
                        :readonly="readonly"
                        autocomplete="false"
                        data-lpignore="true"
                        :maxlength="maxLength ? maxLength : 255"
                        class="form-input block w-full transition duration-150 ease-in-out sm:text-sm leading-none text-gray-700"
                        :class="{ 'border-red-700' : errors[0], 'opacity-50 cursor-not-allowed' : disabled, 'readonly bg-gray-200 cursor-default border-gray-400' : readonly }" />
                </div>
                <span class="text-xs text-red-700 absolute">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InputText",
        props: [
            'label',
            'value',
            'name',
            'providerName',
            'placeholder',
            'readonly',
            'rules',
            'mask',
            'required',
            'type',
            'tooltip',
            'dollar',
            'disabled',
            'percent',
            'blur',
            'suffix',
            'bold',
            'maxLength'
        ],
        data: function(){
            return {
                model: null
            }
        },
        mounted() {
            if (this.value){
                this.model = this.value;
            }
        },
        methods: {
            onInput (event) {
                if (event.target){
                    this.$emit('input', event.target.value);
                } else {
                    // Used for Masked Input
                    this.$emit('input', event);
                }
            },
            onBlur (event) {
                if (event.target){
                    this.$emit('blur', event.target.value);
                } else {
                    // Used for Masked Input
                    this.$emit('blur', event);
                }
            }
        },
        watch: {
            value: function(newVal){
                this.model = newVal;
                this.$emit('input', newVal);
            },
        }
    }
</script>

<style scoped>

</style>
